import { render, staticRenderFns } from "./itemTableInfo.vue?vue&type=template&id=337b90a2&scoped=true&"
import script from "./itemTableInfo.vue?vue&type=script&lang=js&"
export * from "./itemTableInfo.vue?vue&type=script&lang=js&"
import style0 from "./itemTableInfo.vue?vue&type=style&index=0&id=337b90a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b90a2",
  null
  
)

export default component.exports